import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

import { PayPalScriptProvider } from "@paypal/react-paypal-js";
import { AuthProvider } from "./context/auth";
import { PaymentProvider } from "./context/payment";
import { GameProvider } from "./context/game";

const root = ReactDOM.createRoot(document.getElementById("root"));

const initialOptions = {
  "client-id": process.env.REACT_APP_PAYPAL_CLIENT_ID,
  "disable-funding": "",
  currency: "GBP",
  "data-page-type": "product-details",
  components: "buttons",
  "data-sdk-integration-source": "developer-studio",
};

root.render(
  <React.StrictMode>
    <AuthProvider>
      <PaymentProvider>
        <GameProvider>
          <PayPalScriptProvider options={initialOptions}>
            <App />
          </PayPalScriptProvider>
        </GameProvider>
      </PaymentProvider>
    </AuthProvider>
  </React.StrictMode>
);
